<template lang="pug">
  div
    #background(:style="{height: offset <= 200 ? (200 - offset) + 'px' : 0, top: ieTop+'px'}")
      v-navigation-drawer(
        style="z-index: 99"
        app
        temporary
        absolute
        v-model="mobileMenu"
      )
        #background(:style="{height: offset <= 200 ? (200 - offset) + 'px' : 0}")
          v-layout(fill-height align-end v-show="mobileMenu")
            v-flex.pa-4.display-1.white--text Menu
        v-list(:style="{position: 'relative', top: offset <= 96 ? (200 - offset) + 'px' : '96px'}")
          v-list-item-group(:value="menuItems.indexOf(currentMenuItem)")
            v-list-item(
              v-for="menuItem in menuItems"
              :key="menuItem"
              @click="mobileMenu = false; scrollToPage(menuItem)"
              active
            )
              v-list-item-content
                v-list-item-title {{ menuItem }}
      v-layout
        v-flex(xs12 xl10)
          v-btn(outlined dark large @click="mobileMenu = true")#menu-btn.hidden-lg-and-up
            v-icon mdi-menu
            span Menu
          ul#menu(:style="{top: offset <= 104 ? 104 - offset+'px' : 0, zIndex:999}").hidden-md-and-down
            li(v-for="menuItem in menuItems" :key="menuItem" :id="`menu-item-${menuItem}`" @click="scrollToPage(menuItem)") {{menuItem}}
          hr(:style="{top: offset <= 104 ? 196 - offset+'px' : '92px', width: menuStatus.width + 'px', left: menuStatus.left-18 + 'px', zIndex: 999}")#menu-status
    logo(:offset="offset" v-show="!mobileMenu")
    intro-card(:offset="offset")#page-item-Home
    features-card#page-item-Features
    cases-card#page-item-Cases
    contact-card#page-item-Contact
</template>

<script>
import logo from "../components/logo";
import introCard from "../components/introCard";
import featuresCard from "../components/featuresCard";
import casesCard from "../components/casesCard";
import contactCard from "../components/contactCard";

export default {
  data: () => ({
    offset: 0,
    menuItems: ["Home", "Features", "Cases", "Contact"],
    mobileMenu: false,
    currentMenuItem: "Home",
    menuStatus: {}
  }),
  components: {
    logo,
    introCard,
    featuresCard,
    casesCard,
    contactCard
  },
  watch: {
    currentMenuItem() {
      this.updateMenuStatus();
    }
  },
  computed: {
    ieTop () {
      const ua = navigator.userAgent;
      const is_ie = ua.indexOf("MSIE ") > -1 || ua.indexOf("Trident/") > -1;
      return is_ie ? 0 : this.offset
    }
  },
  methods: {
    scrollToPage(id) {
      const scrollbar = this.$root.$children[0].scrollbar;
      const target = document.getElementById(`page-item-${id}`);
      scrollbar.scrollIntoView(target, { offsetTop: 75, alignToTop: true });
      this.$nextTick(() => this.onScroll());
    },
    updateMenuStatus() {
      const currentMenuEl = document.getElementById(
        "menu-item-" + this.currentMenuItem
      );
      const position = currentMenuEl.getBoundingClientRect();
      this.menuStatus = position;
    },
    onScroll(status) {
      const scrollbar = this.$root.$children[0].scrollbar;
      let lastPage = "Home";
      if (!status) {
        status = scrollbar;
      }
      this.offset = status.offset.y;
      let prevPageHeight = null;
      for (let i in this.menuItems) {
        const item = this.menuItems[i];
        const el = document.getElementById(`page-item-${item}`);
        if (el) {
          const position = el.getBoundingClientRect();
          const elOffset = position.y;
          if (this.offset > elOffset && prevPageHeight < 0) lastPage = item;
          prevPageHeight = position.y;
        }
      }
      this.currentMenuItem = lastPage;
      this.updateMenuStatus();
    }
  },
  beforeDestroy() {
    const scrollbar = this.$root.$children[0].scrollbar;
    scrollbar.removeListener(this.onScroll);
  },
  mounted() {
    this.$nextTick(() => {
      const scrollbar = this.$root.$children[0].scrollbar;
      scrollbar.addListener(this.onScroll);
    });
  }
};
</script>
<style lang="css">
.smooth {
  transition: all 0.1s ease;
}
#background {
  background: rgb(0, 181, 203);
  background: -moz-radial-gradient(
    circle,
    rgba(0, 181, 203, 1) 0%,
    rgba(0, 91, 102, 1) 100%
  );
  background: -webkit-radial-gradient(
    circle,
    rgba(0, 181, 203, 1) 0%,
    rgba(0, 91, 102, 1) 100%
  );
  background: radial-gradient(
    circle,
    rgba(0, 181, 203, 1) 0%,
    rgba(0, 91, 102, 1) 100%
  );
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#00b5cb",endColorstr="#005b66",GradientType=1);
  width: 100%;
  min-height: 96px;
  z-index: 1;
  position: fixed;
}
#menu-btn {
  float: left;
  margin: 20px 0 0 20px;
}
#menu {
  float: right;
  /* background-color: blue; */
  height: 96px;
  font-size: 16pt;
  list-style: none;
  position: relative;
}
#menu > li {
  float: left;
  color: white;
  padding-right: 36px;
  line-height: 96px;
  padding-left: 0;
  cursor: pointer;
}
#menu-status {
  border: 2px solid white;
  float: right;
  background: white;
  position: absolute;
  transition: left 500ms ease, width 500ms ease;
}
@media all and (max-width: 1263px) {
  .hidden-md-and-down {
    display: none !important;
  }
}
</style>
